// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"MainPage_mainPage__210rG"};